import { Box, Button, Modal, Typography } from '@mui/material';
import { useMaxWidthTablet } from 'hooks/useMediaQueries';
import { CloseIcon, Snooze as SnoozeIcon } from '../Icons';
import styles from './ForecastFeedbackSnoozeModal.module.scss';

interface Props {
  isModalOpen: boolean;
  onSnoozeCancel: () => void;
  onSnoozeConfirm: () => void;
}

const ForecastFeedbackSnoozeModal: React.FC<Props> = ({
  isModalOpen,
  onSnoozeCancel,
  onSnoozeConfirm,
}) => {
  const isMobile = useMaxWidthTablet();
  return (
    <Modal className={styles.modal} open={isModalOpen}>
      <Box className={styles.content} data-testid="forecast-feedback-snooze-modal">
        <Button
          variant="secondary"
          className={styles.closeButton}
          disableFocusRipple
          disableRipple
          disableTouchRipple
          data-testid="forecast-feedback-snooze-close-button"
          onClick={onSnoozeCancel}
        >
          <CloseIcon />
        </Button>

        <Box className={styles.innerContent}>
          <SnoozeIcon />
          <Typography className={styles.heading} color="text.primary" variant="title2">
            Snooze feedback?
          </Typography>
          <Typography
            className={styles.instructionText}
            color="text.primary"
            variant={isMobile ? 'body' : 'footnote'}
          >
            Click below to snooze the feedback option for 30 days. It’ll disappear from your spot
            pages and pop back up in a month.
          </Typography>
          <Box>
            <Button
              className={styles.snoozeButton}
              color="secondary"
              data-testid="forecast-feedback-snooze-button"
              onClick={onSnoozeConfirm}
              variant="primary"
            >
              Snooze feedback
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default ForecastFeedbackSnoozeModal;
